"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var react_toastify_1 = require("react-toastify");
var AppContainer = function (_a) {
    var noPadding = _a.noPadding, children = _a.children;
    return (react_1.default.createElement("div", { className: "page-wrapper" },
        react_dom_1.default.createPortal(react_1.default.createElement(react_toastify_1.ToastContainer, { position: "bottom-right", autoClose: 8000, hideProgressBar: false, newestOnTop: false, closeOnClick: true, rtl: false, pauseOnFocusLoss: true, pauseOnHover: true }), document.body),
        react_1.default.createElement("div", { className: "page-content", style: noPadding ? {} : { padding: '25px 20px 20px 20px' } }, children)));
};
exports.AppContainer = AppContainer;
exports.default = AppContainer;
//# sourceMappingURL=AppContainer.js.map